export const draftEventsConstants = {
    GET_DRAFT_EVENTS: "GET_DRAFT_EVENTS",
    CANCEL_DRAFT_EVENT: "CANCEL_DRAFT_EVENT",
    VIEW_DRAFT_EVENT_SHUTTERBS: "VIEW_DRAFT_EVENT_SHUTTERBS",
    ASSIGN_SHUTTERBS_TO_DRAFT_EVENT: "ASSIGN_SHUTTERBS_TO_DRAFT_EVENT",
    UNASSIGN_SHUTTERBS_TO_DRAFT_EVENT: "UNASSIGN_SHUTTERBS_TO_DRAFT_EVENT",
    SEND_CART_LINK_TO_CUSTOMER: "SEND_CART_LINK_TO_CUSTOMER",
    DISCARD_EVENT: "DISCARD_EVENT",
  }